import React from "react";
import Hero from "../components/Hero";
import Content from "../components/Content";
import MoreContent from "../components/MoreContent";
import Banner from "../components/Banner";
import Faq from "../components/FAQ";

function Homepage() {
  return (
    <>
      <Hero />
      <Content /> 
      <MoreContent />
      <Faq/>
      <Banner />
    </>
  );
}

export default Homepage;
